import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, useApi } from "@/lib/api";
import { Page, Spinner, Empty } from "@/components/common";
import { fmtDate } from "@/components/EventCard";

export default function Notifications() {
  const qc = useQueryClient();
  const { data, isLoading } = useApi("/notifications");
  useEffect(() => {
    if (data?.unread > 0) api.post("/notifications/read").then(() => qc.invalidateQueries({ queryKey: ["/notifications"] }));
  }, [data?.unread, qc]);
  const list = data?.notifications || [];
  return (
    <Page className="max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">Notifications</h1>
      <div className="mt-8 space-y-3">
        {isLoading ? <Spinner /> : list.length === 0 ? <Empty title="You're all caught up" testId="notifications-empty" /> : list.map((n, i) => (
          <div key={n.id || i} data-testid={`notification-${n.id || i}`} className={`p-5 rounded-2xl border ${n.read ? "bg-white border-stone-200" : "bg-orange-50 border-orange-200"}`}>
            {n.title && <p className="font-semibold">{n.title}</p>}
            <p className="text-sm text-stone-700">{n.message || n.body || n.text}</p>
            <p className="font-mono text-[10px] text-stone-400 mt-1">{fmtDate(n.created_at, "MMM d, h:mm a")}</p>
          </div>
        ))}
      </div>
    </Page>
  );
}
